export default __webpack_public_path__ + "static/media/enhance.1eb4c959.png";